function getConfig(
  key: string,
  required?: boolean
): string | (typeof required extends false ? undefined : never);
function getConfig(key: string, required = true) {
  const value: string | undefined = (window as any)[key];
  if (required && !value) {
    throw new Error(`Missing config '${key}'`);
  }
  return value;
}

export class Config {
  GRAPHQL_API() {
    return getConfig("GRAPHQL_API");
  }
  OKTA_ISSUER() {
    return getConfig("OKTA_ISSUER");
  }
  OKTA_CLIENT_ID() {
    return getConfig("OKTA_CLIENT_ID");
  }
  DEPLOYMENT_ENV() {
    return getConfig("DEPLOYMENT_ENV");
  }
  SENTRY_ENVIRONMENT() {
    return getConfig("SENTRY_ENVIRONMENT");
  }
  // Guard: browser extensions can overwrite window.SENTRY_RELEASE with a non-string (GRAPHQL-W1)
  SENTRY_RELEASE(): string {
    const value = getConfig("SENTRY_RELEASE", false);
    return typeof value === "string" ? value : "unknown";
  }
  SENTRY_DSN() {
    return getConfig("SENTRY_DSN", false);
  }
  // Root the API is served from, i.e. GRAPHQL_API without the /graphql path.
  API_BASE() {
    const url = this.GRAPHQL_API();
    return url.slice(0, url.lastIndexOf("/graphql"));
  }
  SENTRY_TUNNEL() {
    return this.API_BASE() + "/sentry";
  }
  POOL_CLIENT_ID() {
    return getConfig("POOL_CLIENT_ID");
  }
  POOL_ID() {
    return getConfig("POOL_ID");
  }
  POOL_REGION() {
    return getConfig("POOL_REGION");
  }
  PORTAL_URL() {
    return getConfig("PORTAL_URL");
  }
  RCG_SIRIUS_WS_URI() {
    return getConfig("RCG_SIRIUS_WS_URI");
  }
  SIRIUS_URL() {
    return getConfig("SIRIUS_URL");
  }
  COGNITO_DOMAIN() {
    return getConfig("COGNITO_DOMAIN", false);
  }
}

class ConfigWrapper extends Config {
  has(key: keyof Config) {
    return !!(window as any)[key];
  }
}

const config = new ConfigWrapper();

export default config;
